module.exports = __webpack_public_path__ + "static/media/how-to-1.8a4a505f.jpg";